import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-main-detail',
  templateUrl: './main-detail.component.html',
  styleUrls: ['./main-detail.component.scss']
})
export class MainDetailComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

  gotoApp(): void {
    window.open('https://www.itax.me/download', '_blank');
  }

}
